// useLocalStorageCleanup.js
import { useEffect } from 'react';

export default function useLocalStorageCleanup(key) {
  useEffect(() => {
    const SESSION_MARKER = 'session-active';
    const SESSION_TIMESTAMP = 'session-start-time';
    const SESSION_DURATION = 20 * 60 * 1000; // 20 minutes in ms

    // Use full path as a unique marker for this page
    const pageId = window.location.pathname + window.location.search;

    const now = Date.now();
    const storedData = sessionStorage.getItem(SESSION_MARKER);
    const sessionStart = parseInt(sessionStorage.getItem(SESSION_TIMESTAMP), 10);

    if (
      !storedData || 
      storedData !== pageId || // Different page
      !sessionStart || 
      now - sessionStart > SESSION_DURATION
    ) {
      // Clear only for this page
      localStorage.removeItem(key);
      sessionStorage.setItem(SESSION_MARKER, pageId);
      sessionStorage.setItem(SESSION_TIMESTAMP, now.toString());
    }

    const interval = setInterval(() => {
      const startTime = parseInt(sessionStorage.getItem(SESSION_TIMESTAMP), 10);
      if (Date.now() - startTime > SESSION_DURATION) {
        localStorage.removeItem(key);
        sessionStorage.removeItem(SESSION_MARKER);
        sessionStorage.removeItem(SESSION_TIMESTAMP);
        clearInterval(interval);
      }
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, [key]);

  useEffect(() => {
    const handleUnload = () => {
      // If marker exists → it’s a refresh, not a close
      if (!sessionStorage.getItem('page-open')) {
        // No marker means the tab is closing for good
        localStorage.removeItem(key);
      }
    };

    // Set marker when page loads
    sessionStorage.setItem('page-open', 'true');

    window.addEventListener('beforeunload', handleUnload);
    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, [key]);
}
